import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Input from '../../../components/ui/Input'
import { Checkbox } from '../../../components/ui/Checkbox'
import Button from '../../../components/ui/Button'
import { useAuth } from '../../../contexts/AuthContext'

const RegistrationForm = () => {
  const navigate = useNavigate()
  const { signUp } = useAuth()
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    agreeToTerms: false,
    agreeToPrivacy: false
  })
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match')
      return
    }

    if (!formData.agreeToTerms || !formData.agreeToPrivacy) {
      setError('Please accept Terms and Privacy Policy')
      return
    }

    setIsLoading(true)
    setError('')

    try {
      await signUp(formData.email, formData.username, formData.password)
      navigate('/home-feed')
    } catch (submitError) {
      setError(submitError.message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 md:space-y-5 lg:space-y-6">
      <Input label="Username" value={formData.username} onChange={(e) => setFormData((prev) => ({ ...prev, username: e.target.value }))} required />
      <Input label="Email Address" type="email" value={formData.email} onChange={(e) => setFormData((prev) => ({ ...prev, email: e.target.value }))} required />
      <Input label="Password" type="password" value={formData.password} onChange={(e) => setFormData((prev) => ({ ...prev, password: e.target.value }))} required />
      <Input label="Confirm Password" type="password" value={formData.confirmPassword} onChange={(e) => setFormData((prev) => ({ ...prev, confirmPassword: e.target.value }))} required />

      <div className="space-y-3 pt-2">
        <Checkbox label="I agree to the Terms of Service" checked={formData.agreeToTerms} onChange={(e) => setFormData((prev) => ({ ...prev, agreeToTerms: e.target.checked }))} required />
        <Checkbox label="I agree to the Privacy Policy" checked={formData.agreeToPrivacy} onChange={(e) => setFormData((prev) => ({ ...prev, agreeToPrivacy: e.target.checked }))} required />
      </div>

      {error && <p className="text-sm text-error">{error}</p>}

      <Button type="submit" variant="default" size="lg" fullWidth loading={isLoading} className="mt-6">
        Create Account
      </Button>
    </form>
  )
}

export default RegistrationForm
